import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { COMMON, get } from './constants';
import theme from './theme';
import sx from './sx';
var variants = variant({
  scale: 'flash'
});
var Flash = styled.div.withConfig({
  displayName: "Flash",
  componentId: "sc-4y90bn-0"
})(["position:relative;color:", ";padding:", ";border-style:solid;border-width:", ";border-radius:", ";margin-top:", ";p:last-child{margin-bottom:0;}svg{color:", ";margin-right:", ";}", ";", ";", ";"], get('colors.text.grayDark'), get('space.3'), function (props) {
  return props.full ? '1px 0px' : '1px';
}, function (props) {
  return props.full ? '0' : get('radii.2');
}, function (props) {
  return props.full ? '-1px' : '0';
}, function (props) {
  return get("flashIcon.".concat(props.variant))(props.theme);
}, get('space.2'), COMMON, variants, sx);
Flash.defaultProps = {
  theme: theme,
  variant: 'default'
};
Flash.propTypes = _objectSpread(_objectSpread({
  children: PropTypes.node,
  full: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'warning', 'success', 'danger'])
}, COMMON.propTypes), sx.propTypes);
export default Flash;